import { Injectable, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { CLIENT_DATA, TRUSTCOMMANDER_CONFIG } from '@frontend/util-api-data';
import { CookieService } from '@schueco/angular-cookie-consent';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  private document = inject<Document>(DOCUMENT);

  favIcon: HTMLLinkElement;
  clientData = inject(CLIENT_DATA);
  cookieService = inject(CookieService);
  translateService = inject(TranslateService);
  trustcommanderConfig = inject(TRUSTCOMMANDER_CONFIG, { optional: true });

  constructor() {
    this.favIcon = this.document.querySelector('#favIcon')!;
  }

  changeStyles() {
    // Function to load matching stylesheet depending on login
    this.document.body.classList.add(this.clientData.name + '-color-theme');

    this.favIcon.href = `favicon_${this.clientData.name}.ico`;
  }

  changeTrustCommander() {
    if (!this.trustcommanderConfig) {
      return;
    }

    const lang = this.translateService.currentLang;

    const fileName = this.trustcommanderConfig.fileNames[lang] ?? this.trustcommanderConfig.fileNames['en'];
    this.cookieService.initTrustcommanderScript(this.trustcommanderConfig.siteId, fileName);
  }
}
